import { Badge } from 'antd';
import { Link } from 'react-router-dom';

import { TEntityGridColumn } from 'app/common/entity-grid/core';
import { RangeDateFilterDataGrid } from 'app/common/ui/data-grid/filters';
import { appRoute } from 'app/railways/router/routes';
import { appRoute as terminalsAppRouter } from 'app/terminals/router/routes';

import { EOrderStatus } from '../../core/tickets-order';
import { TTicketsReportItem } from '../../core/tickets-report';

export const cols: TEntityGridColumn<TTicketsReportItem>[] = [
  {
    field: 'id',
    // type: 'rightAligned',
    headerName: 'ID',
    minWidth: 50,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    sortable: true,
    comparator: () => 0,
  },
  {
    field: 'date',
    headerName: 'Дата заказа',
    sortable: true,
    colId: 'date',
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      return value ? new Date(value).toLocaleString() : '';
    },
    // @ts-expect-error ...
    filter: RangeDateFilterDataGrid({ filterName: 'date' }),
  },
  {
    field: 'status',
    headerName: 'Статус',
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: EOrderStatus }) => {
      switch (value) {
        case EOrderStatus.created:
          return (
            <Badge
              status="processing"
              text="Создан"
              style={{ whiteSpace: 'nowrap' }}
            />
          );
        case EOrderStatus.ok:
          return (
            <Badge
              status="success"
              text="Выполнен"
              style={{ whiteSpace: 'nowrap' }}
            />
          );
        case EOrderStatus.error:
          return (
            <Badge
              status="error"
              text="Ошибка"
              style={{ whiteSpace: 'nowrap' }}
            />
          );
        case EOrderStatus.booked:
          return (
            <Badge
              status="warning"
              text="Забронирован"
              style={{ whiteSpace: 'nowrap' }}
            />
          );
        case EOrderStatus.canceled:
          return (
            <Badge
              status="default"
              text="Отменен"
              style={{ whiteSpace: 'nowrap' }}
            />
          );
      }
    },
  },
  {
    field: 'description',
    headerName: 'Описание статуса',
    sortable: false,
    colId: 'description',
    comparator: () => 0,
  },
  {
    field: 'departureDate',
    headerName: 'Дата отправления',
    sortable: true,
    colId: 'departureDate',
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      return value ? new Date(value).toLocaleString() : '';
    },
  },
  {
    field: 'arrivalDate',
    headerName: 'Дата прибытия',
    sortable: true,
    colId: 'arrivalDate',
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      return value ? new Date(value).toLocaleString() : '';
    },
  },
  {
    field: 'refundDate',
    headerName: 'Дата возврата денег',
    colId: 'refundDate',
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      return value ? new Date(value).toLocaleString() : '';
    },
  },
  {
    field: 'orderId',
    headerName: 'Заказ',
    sortable: false,
    colId: 'orderId',
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      const path = appRoute.TICKETS.ORDER.buildPath({
        id: value,
      });

      return <Link to={path}>Открыть заказ</Link>;
    },
  },
  {
    field: 'cashierId',
    headerName: 'Кассир',
    sortable: false,
    colId: 'cashierId',
    comparator: () => 0,
    cellRenderer: ({
      value,
      data,
    }: {
      value: number;
      data: TTicketsReportItem;
    }) => {
      const path = terminalsAppRouter.EMPLOYEE.buildPath({
        id: value,
      });

      return <Link to={path}>{data.cashierName}</Link>;
    },
  },
  {
    field: 'summ',
    headerName: 'Сумма',
    sortable: false,
    colId: 'summ',
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      return value != undefined ? `${value} ֏` : '';
    },
  },
  {
    field: 'stationFromName',
    headerName: 'Отправление',
    sortable: false,
    colId: 'stationFromName',
    comparator: () => 0,
  },
  {
    field: 'stationToName',
    headerName: 'Прибытие',
    sortable: false,
    colId: 'stationToName',
    comparator: () => 0,
  },
  {
    field: 'wagonNum',
    headerName: 'Вагон',
    sortable: false,
    colId: 'wagonNum',
    comparator: () => 0,
  },
  {
    field: 'seatNum',
    headerName: 'Место',
    sortable: false,
    colId: 'seatNum',
    comparator: () => 0,
  },
  {
    field: 'routeNumber',
    headerName: '№ маршрута',
    sortable: false,
    colId: 'routeNumber',
    comparator: () => 0,
  },
  {
    field: 'routeName',
    headerName: 'Маршрут',
    sortable: false,
    colId: 'routeName',
    comparator: () => 0,
  },
  {
    field: 'trainTypeName',
    headerName: 'Тип состава',
    sortable: false,
    colId: 'trainTypeName',
    comparator: () => 0,
  },
  {
    field: 'tripStartTime',
    headerName: 'Начало рейса',
    colId: 'tripStartTime',
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      return value ? new Date(value).toLocaleString() : '';
    },
  },
  {
    field: 'tripWagonCount',
    headerName: 'Всего вагонов',
    sortable: false,
    colId: 'tripWagonCount',
    comparator: () => 0,
  },
  {
    field: 'tripSeatCount',
    headerName: 'Всего мест',
    sortable: false,
    colId: 'tripSeatCount',
    comparator: () => 0,
  },
  {
    field: 'tariffTypeName',
    headerName: 'Тариф',
    sortable: false,
    colId: 'tariffTypeName',
    comparator: () => 0,
  },
  {
    field: 'tariffZoneName',
    headerName: 'Зона',
    sortable: false,
    colId: 'tariffZoneName',
    comparator: () => 0,
  },
  {
    field: 'terminalName',
    headerName: 'Терминал',
    sortable: false,
    colId: 'terminalName',
    comparator: () => 0,
  },
];
